export default "__VITE_ASSET__9hxKYo3f__"